module.exports = __webpack_public_path__ + "static/media/auto-clock.4d0459ee.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/auto-clock.scss
// module id = 688
// module chunks = 0